import axios from 'axios'
import { useBoolean } from '@rothzerg/useboolean'
import { isEmail, isEmpty } from '@rothzerg/validator'
import React, { useEffect, useState } from 'react'
import { createUseStyles } from 'react-jss'
import FormInput from '../ui/Form/FormInput'
import FormSelect from '../ui/Form/FormSelect'
import FormTextArea from '../ui/Form/FormTextArea'
import SVG from '../ui/SVG/SVG'

const MissingFFPoints = () => {
  const [countrylist, setcountrylist] = useState([])
  const [formSubmitting, setFormSubmitting] = useBoolean()
  const [agreementNumber, setAgreementNumber] = useState('')
  const [postalCode, setPostalCode] = useState('')
  const [addressOne, setAddressOne] = useState('')
  const [addressTwo, setAddressTwo] = useState('')
  const [membershipNumber, setMembershipNumber] = useState('')
  const [email, setEmail] = useState('')
  const [emailVerify, setEmailVerify] = useState('')
  const [fname, setFname] = useState('')
  const [lname, setLname] = useState('')
  const [rentalDate, setRentalDate] = useState(undefined)
  const [country, setcountry] = useState('')

  // IND FORM

  const [agreementNumberError, setAgreementNumberError] = useState('')
  const [rentalDateError, setRentalDateError] = useState(undefined)
  const [postalCodeError, setPostalCodeError] = useState(undefined)
  const [addressOneError, setAddressOneError] = useState(undefined)
  const [membershipNumberError, setMembershipNumberError] = useState(undefined)
  const [countryError, setcountryError] = useState(undefined)
  const [emailVerifyError, setEmailVerifyError] = useState(undefined)
  const [emailError, setEmailError] = useState(undefined)
  const [fnameError, setFnameError] = useState(undefined)
  const [lnameError, setLnameError] = useState(undefined)
  const [formStatus, setFormStatus] = useState(null)

  const submitForm = () => {
    let error = false

    setEmailVerifyError(undefined)
    setEmailError(undefined)
    setLnameError(undefined)
    setFnameError(undefined)
    setAgreementNumberError(undefined)
    setRentalDateError(undefined)
    setPostalCodeError(undefined)
    setcountryError(undefined)
    setAddressOneError(undefined)
    setMembershipNumberError(undefined)

    if (isEmpty(membershipNumber)) {
      setMembershipNumberError(['Please enter your program membership number'])
      error = true
    }

    if (isEmpty(addressOne)) {
      setAddressOneError(['Please enter your address'])
      error = true
    }

    if (isEmpty(country)) {
      setcountryError(['Please select a country'])
      error = true
    }

    if (isEmpty(postalCode)) {
      setPostalCodeError(['Please enter your zip/postal code'])
      error = true
    }

    if (isEmpty(rentalDate)) {
      setRentalDateError(['Please enter your rental pick-up date'])
      error = true
    }
    if (isEmpty(agreementNumber)) {
      setAgreementNumberError(['Please enter your rental agreement number'])
      error = true
    }
    if (isEmpty(fname)) {
      setFnameError(['Please enter your first name'])
      error = true
    }
    if (isEmpty(lname)) {
      setLnameError(['Please enter your last name'])
      error = true
    }

    if (!isEmail(email)) {
      setEmailError(['Please enter a valid email address'])
      error = true
    }

    if (isEmail(email) && email !== emailVerify) {
      setEmailVerifyError(['Email addresses do not match'])
      error = true
    }

    if (!error) {
      setFormSubmitting.true()

      const params = new URLSearchParams()
      params.append('fname', fname)
      params.append('lname', lname)
      params.append('email', email)
      params.append('membershipNumber', membershipNumber)
      params.append('rentalDate', rentalDate)
      params.append('agreementNumber', agreementNumber)
      params.append('addressOne', addressOne)
      params.append('addressTwo', addressTwo)
      params.append('postalCode', postalCode)
      params.append('country', country)

      axios
        .post('/api/missingpoints', params)
        .then(({ data }) => {
          setFormSubmitting.false()
          setFormStatus(data.status)
          if (data.status === false) {
            alert('Something went wrong. Please try again later.')
          }
        })
        .catch(err => {
          console.error(err)
        })
    }
  }

  const useStyles = createUseStyles(theme => ({
    container: {
      padding: '30px 15px',
      '@media (max-width: 700px)': {
        boxSizing: 'border-box',
        padding: '30px 15px',
      },
    },
    innerCont: { margin: '0 auto', width: '100%', maxWidth: '1220px' },
    title: {
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 700,
      fontFamily: 'TTRounds',
      textAlign: 'left',
      marginBottom: '15px',
      marginTop: 0,
      color: theme.colors.main,
    },
    details: {
      fontSize: '18px',
      lineHeight: '26px',
      fontWeight: 300,
      textAlign: 'left',
      marginBottom: '30px',
      marginTop: 0,
      maxWidth: '560px',
      color: '#000',
      '@media (max-width: 600px)': {
        fontSize: '15px',
        lineHeight: 1.4,
      },
    },
    flexCont: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 20,
      '@media (max-width: 600px)': {
        gridTemplateColumns: '1fr',
        gap: 0,
      },
    },
    flexContFull: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gap: 20,
    },
    formsec: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      '@media (max-width: 600px)': {
        flexDirection: 'column',
      },
    },
    formarea: {
      width: '100%',
      maxWidth: 700,
    },
    tollarea: {
      width: 380,
      '@media (max-width: 600px)': {
        width: '100%',
        marginTop: 60,
      },
    },
    tollareaInner: {
      borderRadius: 20,
      backgroundColor: '#F5F5F5',
      padding: 40,
      boxSizing: 'border-box',
    },
    tollareaTitle: {
      color: theme.colors.main,
      fontSize: 18,
      lineHeight: 1.3,
      marginBottom: 20,
      fontWeight: 'bold',
    },
    tollareaNumber: {
      color: '#2D2D2D',
      fontSize: 15,
      lineHeight: 1.3,
      marginBottom: 10,
      '& a': {
        color: theme.colors.main,
      },
      '& span': {
        '&:first-child': {
          fontWeight: 'bold',
        },
        '&:nth-child(2)': {
          marginLeft: 3,
        },
      },
    },
    buttonPrimary: {
      display: 'inline-block',
      padding: '14px 0',
      border: 'none',
      color: '#fff',
      backgroundColor: theme.colors.orange,
      borderRadius: '15px',
      lineHeight: '18px',
      fontSize: '18px',
      fontWeight: 700,
      textDecoration: 'none',
      width: 215,
      '@media (max-width: 600px)': {
        display: 'block',
        width: '100%',
      },
      '&:hover': {
        backgroundColor: theme.colors.orangeHover,
        cursor: 'pointer',
      },
      '&:disabled': {
        backgroundColor: '#aaa !important',
      },
    },
  }))

  const classes = useStyles()

  useEffect(() => {
    axios.get('/cms/regions').then(res => {
      setcountrylist(res.data)
    })
  }, [])

  return (
    <div className={classes.container}>
      <div className={classes.innerCont}>
        <div className={classes.formsec}>
          <div className={classes.formarea}>
            <div className={classes.details}>
              Please allow a minimum of thirty days after returning your rental before submitting
              this request.
            </div>
            {formStatus === true ? (
              <div className={classes.form}>
                <div
                  style={{
                    border: '1px solid #F7F7F7',
                    boxShadow: '1px 5px 15px rgba(0, 0, 0, 0.15)',
                    borderRadius: 20,
                    padding: '50px 25px',
                    marginTop: 25,
                  }}
                >
                  <div
                    style={{
                      color: '#11BA22',
                      display: 'flex',
                      alignItems: 'center',
                      fontSize: '25px',
                      marginBottom: 10,
                    }}
                  >
                    <SVG
                      name="TickCircle"
                      width={24}
                      height={24}
                      colorOne="#fff"
                      colorTwo="#11BA22"
                    />
                    <span style={{ display: 'inline-block', paddingLeft: 10 }}>Success</span>
                  </div>
                  <div style={{ fontSize: '20px', lineHeight: 1.3 }}>
                    Thank you for for your enquiry, we will be in touch with you shortly.
                  </div>
                  <div style={{ textAlign: 'center', paddingTop: 40 }}>
                    <button
                      onClick={() => setFormStatus(null)}
                      className={classes.buttonPrimary}
                      style={{ width: 250 }}
                    >
                      Create another request
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className={classes.form}>
                <div className={classes.title}>Program Details</div>
                <div className={classes.flexContFull}>
                  <div>
                    <FormInput
                      noMarginBottom
                      greyBackground={true}
                      disabled={formSubmitting}
                      error={membershipNumberError}
                      labelText="Program Membership Number*"
                      inputType="text"
                      defaultValue=""
                      onChange={el => {
                        setMembershipNumber(el.currentTarget.value)
                      }}
                    />
                    <div style={{ padding: '10px', fontSize: '13px', fontWeight: 300 }}>
                      Please include all digits of your membership number as it appears on your
                      card, with no space or dashes between them. Include any leading zores.
                    </div>
                  </div>
                </div>

                <div className={classes.title} style={{ marginTop: '25px' }}>
                  Member Details
                </div>
                <div className={classes.flexCont}>
                  <div>
                    <FormInput
                      greyBackground={true}
                      disabled={formSubmitting}
                      error={fnameError}
                      labelText="First Name*"
                      inputType="text"
                      defaultValue=""
                      onChange={el => {
                        setFname(el.currentTarget.value)
                      }}
                    />
                  </div>
                  <div>
                    <FormInput
                      greyBackground={true}
                      disabled={formSubmitting}
                      error={lnameError}
                      labelText="Last Name*"
                      inputType="text"
                      defaultValue=""
                      onChange={el => {
                        setLname(el.currentTarget.value)
                      }}
                    />
                  </div>
                </div>

                <div className={classes.flexContFull}>
                  <FormInput
                    greyBackground={true}
                    disabled={formSubmitting}
                    error={addressOneError}
                    labelText="Address Line 1*"
                    inputType="text"
                    defaultValue=""
                    onChange={el => {
                      setAddressOne(el.currentTarget.value)
                    }}
                  />
                </div>

                <div className={classes.flexContFull}>
                  <FormInput
                    greyBackground={true}
                    disabled={formSubmitting}
                    labelText="Address Line 2"
                    inputType="text"
                    defaultValue=""
                    onChange={el => {
                      setAddressTwo(el.currentTarget.value)
                    }}
                  />
                </div>

                <div className={classes.flexCont}>
                  <div>
                    <FormSelect
                      noSearch
                      greyBackground
                      placeholder="Country*"
                      labelText="Country"
                      optionsArray={countrylist}
                      defaultValue={country}
                      error={countryError}
                      onChange={el => {
                        setcountry(el.target.value)
                      }}
                    />
                  </div>
                  <div>
                    <FormInput
                      disabled={formSubmitting}
                      greyBackground={true}
                      labelText="Zip/Postal Code*"
                      inputType="text"
                      defaultValue=""
                      error={postalCodeError}
                      onChange={el => {
                        setPostalCode(el.currentTarget.value)
                      }}
                    />
                  </div>
                </div>

                <div className={classes.flexCont}>
                  <div>
                    <FormInput
                      disabled={formSubmitting}
                      greyBackground={true}
                      labelText="Email*"
                      inputType="email"
                      defaultValue=""
                      error={emailError}
                      onChange={el => {
                        setEmail(el.currentTarget.value)
                      }}
                    />
                  </div>
                  <div>
                    <FormInput
                      disabled={formSubmitting}
                      greyBackground={true}
                      labelText="Verify Your Email*"
                      inputType="email"
                      defaultValue=""
                      error={emailVerifyError}
                      onChange={el => {
                        setEmailVerify(el.currentTarget.value)
                      }}
                    />
                  </div>
                </div>

                <div className={classes.title} style={{ marginTop: '25px' }}>
                  Rental Details
                </div>
                <div className={classes.flexContFull}>
                  <FormInput
                    greyBackground
                    labelText="Rental Pick-up Date*"
                    inputType="masked"
                    maskType="date"
                    error={rentalDateError}
                    defaultValue={
                      /\d{4}-\d{2}-\d{2}/i.test(rentalDate)
                        ? moment(rentalDate, 'YYYY-MM-DD').format('DDMMYYYY')
                        : undefined
                    }
                    onChange={el => {
                      setRentalDate(el.currentTarget.value)
                    }}
                  />
                </div>
                <div className={classes.flexContFull}>
                  <FormInput
                    greyBackground={true}
                    disabled={formSubmitting}
                    error={agreementNumberError}
                    labelText="Rental Agreement Number*"
                    inputType="text"
                    defaultValue=""
                    onChange={el => {
                      setAgreementNumber(el.currentTarget.value)
                    }}
                  />
                </div>

                <div className={classes.flexContFull}>
                  <div style={{ paddingTop: 20 }}>
                    <button
                      onClick={submitForm}
                      className={classes.buttonPrimary}
                      disabled={formSubmitting}
                    >
                      {formSubmitting ? 'Submitting' : 'Submit'}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className={classes.tollarea}>
            <div style={{ paddingBottom: '50px', textAlign: 'center' }}>
              <img
                style={{ height: 'auto', width: '200px' }}
                src="/themes/thrifty/assets/images/missing-points.png"
              />
            </div>
            <div className={classes.tollareaInner}>
              <div className={classes.tollareaTitle}>
                For more information on Velocity Frequent Flyer:
              </div>
              <div className={classes.tollareaNumber}>
                <span>Australia:</span>
                <span>
                  <a href={`tel:131 875`}>131 875</a>
                </span>
              </div>

              <div className={classes.tollareaNumber}>
                <span>New Zealand:</span>
                <span>
                  <a href={`tel:0800 230 875`}>0800 230 875</a>
                </span>
              </div>

              <div className={classes.tollareaNumber}>
                <span>Other international locations:</span>
                <span>
                  <a href={`tel:+61 2 8667 5924`}>+61 2 8667 5924</a>
                </span>
              </div>

              <div className={classes.tollareaNumber}>
                <span>Visit:</span>
                <span>
                  <a href="https://www.velocityfrequentflyer.com" target="_blank" rel="noreferrer">
                    velocityfrequentflyer.com
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MissingFFPoints
